import {
  DocumentTypesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
  PlanAccountsSelect,
} from '@/components/_common';
import { EmployeeCommissionListFormValues } from '@/core/domain/enterprise/EmployeeCommission/EmployeeCommission.types';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import {
  Alert,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
} from 'antd';
import { FormInstance } from 'antd/es/form/Form';

interface Props extends ModalProps {
  form: FormInstance<EmployeeCommissionListFormValues>;
  onOk: () => void;
  onCancel: () => void;
}

const EmployeePayCommissionModal = ({ form, ...props }: Props) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Modal
      {...props}
      title="Quitar comissão selecionada"
      okText="Quitar comissões"
      width="70%"
      destroyOnClose
      onOk={() => {
        props.onOk();
        props.onCancel();
      }}
    >
      <Alert
        type="warning"
        description="Atenção: Ao gerar a conta a pagar, o documento será registrado com situação 'Aberto'. 
          O pagamento efetivo deverá ser realizado através do módulo de Contas a Pagar."
        style={{ marginBottom: 16 }}
      />

      <p>Informe a data de pagamento da comissão selecionada.</p>

      <Form form={form} preserve={false}>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            <FloatingFormItem
              name="comissionDate"
              label="Data de pagamento"
              rules={[defaultEmptyFieldError]}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem name="comissionObservation" label="Observação">
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={24}>
            <FloatingFormItem
              name="isGenerateAccountsPayable"
              valuePropName="checked"
              initialValue={true}
            >
              <Checkbox disabled>Gerar contas a pagar</Checkbox>
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              label="Plano de Contas"
              name="planAccountId"
              rules={[defaultEmptyFieldError]}
            >
              <PlanAccountsSelect
                queryFilter={{
                  hierarchy: PlanAccountHierarchy.Analitical,
                  destination: PlanAccountDestination.Expense,
                  active: true,
                }}
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              label="Tipo de Documento"
              name="documentTypeId"
              rules={[defaultEmptyFieldError]}
            >
              <DocumentTypesInfiniteSelectField />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EmployeePayCommissionModal;
